export default __webpack_public_path__ + "static/media/screen6.2fe0d65e.jpg";